import React, { Fragment } from 'react';
import './style.css'
import Header from '../../components/Header';

const PrivacyPolicy = () => {
  return (
    <Fragment>
        <Header/>
    <div className="privacy-policy-container col-md-12">
      <h2 className="main-heading ">PRIVACY POLICY</h2>

      <h3>Indira School Of Business Studies Privacy Statement</h3>
      <p>
        We respect the privacy of all visitors to our website. Through the course of operations, we collect information about visitors through multiple methods and for a number of reasons.
      </p>

      <h3>Anonymous Information</h3>
      <p>
        Anonymous information concerning the browsing habits of our visitors is collected to inform future design decisions that enhance the user experience. This anonymous user information is collected through third-party vendors, including Google, that specialize in website analytics.
      </p>

      <h3>Personal Information</h3>
      <p>
        Any personal or contact information voluntarily shared by users through online forms is protected through internal processes and is never sold to third parties. During regular operations, we do store some contact information in third-party service providers that we use regularly for communication purposes.
      </p>
      <p>
        When you voluntarily send us electronic mail or fill out a form, we keep a record of this information to respond appropriately. We collect information from you only when you register on our site or submit a form. When doing so, you may be asked to enter your name, email address, or phone number. However, you may also visit our site anonymously.
      </p>
      <p>
        In case you have submitted your personal information and contact details, we reserve the right to contact you via Call, SMS, Email, or WhatsApp about our products and offers—even if your number is registered under DND (Do Not Disturb).
      </p>

      <h3>Links</h3>
      <p>Our website contains links to other websites. Please note that when you follow these links, you are entering another website and our privacy policy is no longer in effect. We encourage you to read the privacy statements of these linked sites</p>
      <h3>Cookies</h3>
      <p>We track our website traffic through the Google Analytics platform. We, and third-party vendors including Google, use cookies stored on your computer to report how interactions with advertising and advertising services are related to our website traffic.</p>
      <h3>Changes</h3>
      <p>Our Privacy Statement may change from time to time. We will update any changes on this page and, if the changes are significant, we may provide a more prominent notice.</p>
      <h3>Questions</h3>
      <p>If you have any questions about this statement, please contact us at: <a href="mailto:info@.indiraisbs.edu.in" target="_blank" rel="noopener noreferrer">
        info@indiraisbs.edu.in
  </a></p>
    </div>
    </Fragment>
  );
};

export default PrivacyPolicy;
